module.exports = __webpack_public_path__ + "1d2977dda3611fb57e99c16faf3be960.svg";